const isPlatformSubdomain = (subdomain: string) => (
  subdomain === "platform" || subdomain === "eu-platform" || subdomain === "platform-staging" || subdomain === "localhost:4000"
);

export default isPlatformSubdomain;
